<template>
  <!-- Pastille d'icône « 3D » : même langage que le bouton soleil — une ombre
       franche (épaisseur) dans une teinte plus foncée du fond. -->
  <span class="inline-flex items-center justify-center flex-shrink-0 rounded-full" :class="TONES[tone]" :style="{
    width: `${size}px`,
    height: `${size}px`,
    boxShadow: `0 ${depth}px 0 0 var(--tile-edge)`,
  }">
    <LucideIcon :name="icon" :size="iconSize ?? Math.round(size / 2)" :fallback="fallback" />
  </span>
</template>

<script setup lang="ts">
import LucideIcon from '@/components/common/LucideIcon.vue'

export type IconTileTone =
  | 'child'
  | 'child-solid'
  | 'brand'
  | 'brand-solid'
  | 'joy'
  | 'olive'
  | 'sky'
  | 'premium'
  | 'neutral'
  | 'danger'

withDefaults(defineProps<{
  icon: string
  /** Côté du carré en px. */
  size?: number
  /** Taille de l'icône ; défaut = moitié du carré. */
  iconSize?: number
  /** Palette : `child` suit le contexte .child-* ; les autres sont fixes. */
  tone?: IconTileTone
  /** Épaisseur de l'ombre franche en px. */
  depth?: number
  /** Icône de secours si `icon` (ex. nom venant de la DB) est introuvable. */
  fallback?: 'refresh' | 'sparkles' | 'help' | null
}>(), {
  size: 32,
  tone: 'child',
  depth: 3,
  fallback: null,
})

// fond / encre / tranche (--tile-edge) par ton. Les tranches sont la teinte
// 200-300 du fond (tokens Soleil de src/index.css).
const TONES: Record<IconTileTone, string> = {
  child: 'bg-[var(--child-100)] text-[var(--child-700)] [--tile-edge:var(--child-300)]',
  'child-solid': 'bg-[var(--child-700)] text-white [--tile-edge:var(--child-900)]',
  brand: 'bg-brand-soft text-brand-deep [--tile-edge:#EDC676]',
  'brand-solid': 'bg-brand text-brand-ink [--tile-edge:var(--color-brand-edge)]',
  joy: 'bg-joy-soft text-joy [--tile-edge:#EDC676]',
  olive: 'bg-olive-soft text-olive [--tile-edge:#CCD8B8]',
  sky: 'bg-sky text-sky-ink [--tile-edge:#C2D6E6]',
  premium: 'bg-premium-soft text-premium [--tile-edge:var(--color-premium-edge)]',
  neutral: 'bg-warm-2 text-ink-2 [--tile-edge:var(--color-line-strong)]',
  danger: 'bg-danger-soft text-danger [--tile-edge:#EEC0B4]',
}
</script>
